import React, { useEffect, useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

const ALLOWED_MODULES = [4, 10];

export default function DepartmentalRoles() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);

  const [departments, setDepartments] = useState([]);
  const [employees,   setEmployees]   = useState([]);

  const [departmentID, setDepartmentID] = useState("");
  const [employeeID,   setEmployeeID]   = useState("");
  const [fromDate,     setFromDate]     = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  useEffect(() => {
    if (!ALLOWED_MODULES.includes(moduleId)) return;

    fetch(`${API_ROOT}/api/directory/departments`)
      .then(r => r.json())
      .then(data => setDepartments(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetch(`${API_ROOT}/api/employees/departmental-roles/employees`)
      .then(r => r.json())
      .then(data => setEmployees(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ALLOWED_MODULES.includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  const handleSave = async (e) => {
    e.preventDefault();
    if (!departmentID || !employeeID || !fromDate) {
      setMessage({ text: "Invalid input. Please fill all fields correctly.", type: "danger" });
      return;
    }
    setLoading(true);
    setMessage({ text: "", type: "" });
    try {
      const res  = await fetch(`${API_ROOT}/api/employees/departmental-roles/save`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ employeeID, departmentID, fromDate }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ text: data.message || "Saved.", type: "success" });
        setDepartmentID(""); setEmployeeID(""); setFromDate("");
      } else {
        setMessage({ text: data.message || "Error saving.", type: "danger" });
      }
    } catch {
      setMessage({ text: "Error saving department role.", type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <h4 className="ctitle">Departmental Roles</h4>

      {message.text && (
        <div className={`alert alert-${message.type} alert-dismissible`}>
          {message.text}
          <button type="button" className="btn-close" onClick={() => setMessage({ text: "", type: "" })} />
        </div>
      )}

      <form className="row g-2 align-items-end" onSubmit={handleSave}>
        <div className="col-md-5">
          <label className="form-label">Select Department</label>
          <select
            className="form-select form-select-sm"
            value={departmentID}
            onChange={e => setDepartmentID(e.target.value)}
            required
          >
            <option value="">Select Department</option>
            {departments.map(d => (
              <option key={d.DepartmentID} value={d.DepartmentID}>{d.Department}</option>
            ))}
          </select>
        </div>

        <div className="col-md-5">
          <label className="form-label">Select Employee</label>
          <select
            className="form-select form-select-sm"
            value={employeeID}
            onChange={e => setEmployeeID(e.target.value)}
            required
          >
            <option value="">Select Employee</option>
            {employees.map(emp => (
              <option key={emp.EmployeeID} value={emp.EmployeeID}>
                {emp.EmpName} — {emp.Department} — {emp.Designation}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label">From Date</label>
          <input
            className="form-control form-control-sm"
            type="date"
            value={fromDate}
            onChange={e => setFromDate(e.target.value)}
            required
          />
        </div>

        <div className="col-auto mt-1">
          <button className="btn btn-success btn-sm" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
